export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_09.4257c646.jpg";